import "@/shared/lib/i18n/config";
import { IntercomProvider } from "@/features/common/intercom";
import { ToastProvider } from "@cronika/ui";
import { AppGuard } from "@/core/guards";
import { LocaleProvider } from "./LocaleProvider";
import { ReactNode } from "react";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <IntercomProvider>
      <ToastProvider />
      <LocaleProvider>
        <AppGuard>{children}</AppGuard>
      </LocaleProvider>
    </IntercomProvider>
  );
}
